import { useGlobal } from '@/utils/useGlobal';
import { TweenMax, TimelineMax } from 'gsap';
import css from './index.module.scss';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/dg200/');

export default function ImgE() {
    const { useLang, isMobile, useEffect } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');

    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        // 黑夜到白昼
        const sceneA = new ScrollMagic.Scene({
            triggerElement: '.dg200 .imgE',
            offset: layoutH,
            triggerHook: 1,
            duration: layoutH,
        });
        const timeline = new TimelineMax();
        const tween1 = TweenMax.to('.dg200 .imgE .imgs .imgBox2', 0.5, { opacity: 0 });
        // const tween2 = TweenMax.to('.dg200 .imgE .imgs .imgBox1', .5, { opacity: 1 })
        timeline.add(tween1);
        sceneA.setTween(timeline);
        controller.addScene(sceneA);
    }, []);

    // 文字渐变
    useEffect(() => {
        if (isMobile) {
            const scene1 = new ScrollMagic.Scene({
                triggerElement: '.dg200 .imgE',
                offset: layoutH * 2,
                triggerHook: 1,
                duration: 200,
            });
            const tween1 = TweenMax.fromTo(
                '.dg200 .imgE .textBox',
                0.5,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                },
            );

            scene1.setTween(tween1);
            controller.addScene(scene1);
        }
    }, []);

    return (
        <div className={`imgE ${css.imgE} ${isMobile ? 'imgE_h5' : 'imgE_pc'}`}>
            <div className="imgEBox">
                <div className="imgs">
                    <div className="imgBox imgBox1">
                        <EFPic
                            name={[`${isMobile ? 'h5/' : 'pc/'}4_2.jpg`, `${isMobile ? 'h5/' : 'pc/'}4_2.jpg`]}
                            // layout="fill"
                            className="fullImgs"
                            alt={t('dg200.imgE_text')}
                            aria-label={t('dg200.imgE_text')}
                        />
                    </div>
                    <div className="imgBox imgBox2">
                        <EFPic
                            name={[`${isMobile ? 'h5/' : 'pc/'}4_1.jpg`, `${isMobile ? 'h5/' : 'pc/'}4_1.jpg`]}
                            // layout="fill"
                            className="fullImgs"
                            alt={t('dg200.imgE_text')}
                            aria-label={t('dg200.imgE_text')}
                        />
                    </div>
                </div>
                <div
                    className="textBox"
                    style={
                        !isMobile
                            ? {
                                  top: layoutH > 1080 ? 1080 - 64 + 32 + 'px' : 'calc(100vh - 64px + 32px)',
                              }
                            : {}
                    }
                >
                    <div className="text">{t('dg200.imgE_text')}</div>
                </div>
            </div>
        </div>
    );
}
